export { default as LifestylesClientFilter } from './LifestylesClientFilter';
